import { BaseWebComponentController, IListenerConfig } from '../../../../../framework/BaseWebComponentController';
import { InProductTrialsAppWebComponent } from '../../../inProductTrialsApp';
import { templateProductTrialsOverlayWindow } from '../view/template';
import { InProductTrialsOverlayContentView } from '../view/InProductTrialsOverlayContentView';
import { InProductTrialsOverlayContentWebComponent } from '../component/InProductTrialsOverlayContentWebComponent';
import { ButtonEvents } from '../../../../../ui/gzButton/types';
import {
  InProductTrialsOverlayWindowEventType,
  OnInProductTrialsOverlayWindowButtonClick,
} from '../events/InProductTrialsOverlayWindowEventType';
import { InProductTrialsOverlayWindowType } from '../../types/InProductTrialsOverlayWindowType';

export class InProductTrialsOverlayContentController extends BaseWebComponentController {
  public component: InProductTrialsOverlayContentWebComponent;
  public view: InProductTrialsOverlayContentView;
  public viewConstructor: typeof InProductTrialsOverlayContentView;

  constructor(component: InProductTrialsAppWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: InProductTrialsOverlayContentView,
      viewTemplate: templateProductTrialsOverlayWindow,
    });
  }

  async getDataForView(): Promise<{ inProductTrialsOverlayWindowType: InProductTrialsOverlayWindowType }> {
    return {
      inProductTrialsOverlayWindowType: this.component.inProductTrialsOverlayWindowType,
    };
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$button1,
        event: ButtonEvents.CLICK,
        callback: () => {
          this.handleButtonClick(this.view.overlayWindowConfig.buttons.button1.event);
        },
      },
      {
        element: this.view.dom.$button2,
        event: ButtonEvents.CLICK,
        callback: () => {
          this.handleButtonClick(this.view.overlayWindowConfig.buttons.button2.event);
        },
      },
      {
        element: this.view.dom.$button3,
        event: ButtonEvents.CLICK,
        callback: () => {
          this.handleButtonClick(
            this.view.overlayWindowConfig.buttons.button3?.event ?? InProductTrialsOverlayWindowEventType.Default
          );
        },
      },
    ];
  }

  private handleButtonClick(eventType: InProductTrialsOverlayWindowEventType) {
    this.component.dispatchEvent(new OnInProductTrialsOverlayWindowButtonClick(eventType));
  }
}
